/* eslint-disable */
export default {
  conferenceCall: 'Conférence téléphonique',
  onHold: 'En attente',
  ongoing: 'En cours',
  unknown: 'Inconnu',
  disconnected: 'Déconnecté',
  loading: 'Chargement…',
  loadingTimeout: 'Délai d’expiration du chargement.',
} as const;

// @key: @#@"conferenceCall"@#@ @source: @#@"Conference Call"@#@
// @key: @#@"onHold"@#@ @source: @#@"On Hold"@#@
// @key: @#@"ongoing"@#@ @source: @#@"Ongoing"@#@
// @key: @#@"unknown"@#@ @source: @#@"Unknown"@#@
// @key: @#@"disconnected"@#@ @source: @#@"Disconnected"@#@
// @key: @#@"loading"@#@ @source: @#@"Loading ..."@#@
// @key: @#@"loadingTimeout"@#@ @source: @#@"Loading timeout."@#@
